<template>
	<el-submenu :show-timeout="0" :hide-timeout="0" v-if="item.children" :index="item.path">
		<template slot="title">
			<i class="nav-icon iconfont" :class="item.icon" v-if="item.icon"></i>
			<span slot="title" class="ellipsisTxt">{{ item.title}}</span>
		</template>
		<el-menu-item-group class="menuGroup">
			<template v-for="(child, i) in item.children" >
				<template v-if="$_auth(child.auth) && child.isMenu">
					<navItem  :item="child" v-if="child.children"  :key="i"></navItem>
					<el-menu-item v-else :key="i" :index="child.path" >
						<span class="ellipsisTxt">{{ child.title }}</span>
					</el-menu-item>
				</template>
			</template>
		</el-menu-item-group>
	</el-submenu>
	<el-menu-item :index="item.path" :key="item.url" v-else>
		<i class="nav-icon iconfont" :class="item.icon" v-if="item.icon"></i>
		<span slot="title">{{ item.title }}</span>
	</el-menu-item>
</template>

<script>
export default {
	name: 'navItem',
	props: ['item'],
	data(){
		return {

		}
	}
}
</script>

<style lang="scss" scoped>
.nav-icon{
	font-size: 16px;
	margin-right: 10px;
}
	
</style>
